@if (inited) {
    <sm-table class="height100p" [data]="table">
    </sm-table>
}